import React from 'react';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

export const TrackingContext = React.createContext<TrackingServiceV2>({} as TrackingServiceV2);
